import * as types from '../mutation-types'

// initial state
export const initialState = () => {
    return {
        sitekey: "",
        token: null
    }
}
let state = initialState()

// getters
const getters = {
  turnstileToken: (state) => state.token
}

// actions
const actions = {
  loadTurnstile({ commit }) {
    let sitekey = process.env.VUE_APP_TURNSTILE_SITE_KEY;

    if (sitekey) {
      commit(types.TURNSTILE_SET_SITEKEY, sitekey);
    }

    if (!sitekey || (window.turnstile && window.turnstile.render) || document.getElementById("turnstile-script")) {
      return;
    }

    const f = document.getElementsByTagName("script")[0];
    const j = document.createElement("script");

    j.async = true;
    j.id = "turnstile-script";
    j.defer = true;
    j.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    f.parentNode.insertBefore(j, f);
  },

  unloadTurnstile({ }) {
    const turnstileScript = document.getElementById("turnstile-script");
    if (turnstileScript) {
      turnstileScript.parentNode.removeChild(turnstileScript);
    }
  },

  renderTurnstile({ state, commit, dispatch }) {
    if (!state.sitekey) {
      return;
    }
  
    let intervalId;
  
    const timeoutId = setTimeout(() => {
      clearInterval(intervalId); 
      dispatch('application/setLoader', false, { root: true })
    }, 10000);
  
    intervalId = setInterval(() => {
      if (window.turnstile && window.turnstile.render) {
        clearInterval(intervalId); 
  
        clearTimeout(timeoutId);
  
        window.turnstile.render('#turnstile-container', {
          sitekey: state.sitekey,
          callback: (token) => {
            commit(types.TURNSTILE_SET_TOKEN, token);
          },
        });
      }
    }, 100);
  },

  resetTurnstile() {
    if (!state.sitekey) {
      return;
    }
    if (window.turnstile) {
      window.turnstile && window.turnstile.reset();
    }
  },

  clearTurnstileToken({ commit }) {
    commit(types.TURNSTILE_SET_TOKEN, '');
  }
}

// mutations
const mutations = {
  [types.TURNSTILE_SET_SITEKEY](state, value) {
    state.sitekey = value;
  },
  [types.TURNSTILE_SET_TOKEN](state, value) {
    state.token = value;
    this.dispatch('application/setLoader', false)
  }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
